<template>
  <div class="MarketingPlans">
    <!-- <div class="bntGroup">
			<base-button @click="GoBack()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div> -->
    <div class="filter-tag-row">
      <ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false" />
      <span
        v-if="this.ApiData"
        class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary"
        >Пакетов: {{ this.masApi_total }}</span
      >
    </div>

    <div class="row" v-show="bShowFilter">
      <div class="col-12">
        <ReFilter
          :masAllFilterParams="masAllFilterParams"
          v-model="objGetParams"
          v-on:filterapply="OnFilterApply"
          name="MarketingPlans"
        />
      </div>
    </div>

    <tabs
      type="primary"
      :activeTab="strCurrentTab"
      @change="OnTabChange"
      tabContentClasses="tab-opt"
      centered
      inline
      round
      v-loading.fullscreen.lock="$GVO.fullscreenLoading"
      element-loading-text="Загрузка данных..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="card card-plain"
    >
      <tab-pane :id="'table'">
        <template v-slot:label>
          <span class="tab-label">
            <span>Таблица</span>
          </span>
        </template>

        <card>
          <!-- <ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Сохранить" /> -->
          <el-table :data="ApiData" style="width: 100%">
            <el-table-column min-width="180" label="Объект" prop="full_address">
              <template v-slot="scope">
                <router-link
                  tag="a"
                  :to="`/data/module/mo/object/${scope.row.object_id}`"
                >
                  {{ scope.row.full_address }}
                </router-link>
              </template>
            </el-table-column>

            <el-table-column
              min-width="120"
              label="Цена"
              property="price"
              align="right"
            >
              <template v-slot="scope">
                <span v-if="scope.row.price"
                  >{{
                    $GVO.number_format(scope.row.price, 0, ",", " ")
                  }}
                  ₽</span
                >
              </template>
            </el-table-column>
            <el-table-column
              min-width="180"
              label="Название пакета"
              property="name"
            >
            </el-table-column>

            <el-table-column
              min-width="160"
              label="Дата подачи"
              property="dfrom"
            >
              <template v-slot="scope">
                <span v-if="scope.row.price">{{
                  $GVO.convertDateFromMysql(scope.row.dfrom)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column min-width="160" label="Дата снятия" property="dto">
              <template v-slot="scope">
                <span v-if="scope.row.price">{{
                  $GVO.convertDateFromMysql(scope.row.dto)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              min-width="260"
              label="Сотрудник"
              property="fio"
              v-if="isBoss"
            >
            </el-table-column>
            <el-table-column min-width="260" label="Статус" property="actual">
              <!-- <template slot-scope="scope">	
								Площадки: {{scope.row.sites_count}} - Стоимость: {{scope.row.price}} ₽
							</template> -->
            </el-table-column>
            <el-table-column
              min-width="150"
              label="Автопродление"
              property="autoprolongate"
            >
              <template v-slot="scope">
                <template
                  v-if="
                    scope.row.agent_id == $GVO.my_profile.code &&
                    scope.row.has_autoprolongate == 1
                  "
                >
                  <ReActionBtns
                    v-if="planButtons[scope.row.plan_id]"
                    :masActions="planButtons[scope.row.plan_id]"
                  />
                </template>
                <template v-else>
                  {{ isAutoprolongateEnabled(scope.row) }}
                </template>
              </template>
            </el-table-column>
            <el-table-column
              min-width="160"
              label="Стоимость продления"
              property="marketing_price"
            >
            </el-table-column>
          </el-table>
          <Pagination
            class="mt-3"
            :class="[
              { '': parseInt(masApi_total) > 0 },
              { 'd-none': parseInt(masApi_total) < 1 },
            ]"
            :type="'info'"
            :total="parseInt(masApi_total)"
            :perPage="parseInt(10)"
            :value="
              parseInt(
                typeof objGetParams.p == 'undefined' ? 1 : objGetParams.p
              )
            "
            :pClick="pClick"
          >
          </Pagination>
        </card>
      </tab-pane>
      <tab-pane :id="'diagram'">
        <template v-slot:label>
          <span class="tab-label">
            <span>Диаграмма Ганта</span>
          </span>
        </template>
        <card>
          <!--div>
					ROW : {{rows }}
					<a href="https://github.com/zunnzunn/vue-ganttastic/tree/vue-ganttastic-v1">https://github.com/zunnzunn/vue-ganttastic/tree/vue-ganttastic-v1</a>
					</div-->
          <g-gantt-chart
            v-if="strCurrentTab == 'diagram'"
            :chart-start="myChartStart"
            :chart-end="myChartEnd"
            :bar-start="myChartStart"
            :bar-end="myChartEnd"
            theme="creamy"
            rowLabelWidth="min(15%,350px)"
          >
            <g-gantt-row
              v-for="row in rows"
              :key="row.plan_id"
              :label="row.label"
              :bars="row.bars"
              bar-start="myStart"
              bar-end="myEnd"
            >
              <template v-slot:label>
                <router-link :to="'/data/module/mo/object/' + row.object_id">
                  {{ row.label }}
                </router-link>
              </template>
            </g-gantt-row>
          </g-gantt-chart>
          <Pagination
            class="mt-3"
            :class="[
              { '': parseInt(masApiGant_total) > 0 },
              { 'd-none': parseInt(masApiGant_total) < 1 },
            ]"
            :type="'info'"
            :total="parseInt(masApiGant_total)"
            :perPage="parseInt(10)"
            :value="
              parseInt(
                typeof objGetParams.pg == 'undefined' ? 1 : objGetParams.pg
              )
            "
            :pClick="pClickGant"
          >
          </Pagination>
        </card>
      </tab-pane>
    </tabs>
  </div>
</template>
<script>
import { eventEmitter } from "src/plugins/globalComponents.js";
//import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
import ReFilter from "src/our_components/FilterPrinter/ReFilter.vue";
import ReFilterBtn from "src/our_components/FilterPrinter/ReFilterBtn.vue";
import Pagination from "src/our_components/RePagination";
import {
  Table,
  TableColumn,
  Select,
  Option,
  Tooltip,
  Button,
} from "element-ui";
import { TabPane, Tabs } from "src/components";
// import LineChart from "src/components/Charts/LineChart";
import { GGanttChart, GGanttRow } from "/src/clone_modules/vue-ganttastic/src";
import ReActionBtns from "../../our_components/ReActionBtns.vue";
import moment from "moment";

export default {
  name: "MarketingPlans-page",
  components: {
    //ReFormPrinter,
    ReFilter,
    ReFilterBtn,
    Pagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    TabPane,
    Tabs,
    // LineChart,
    GGanttChart,
    GGanttRow,
    ReActionBtns,
  },
  data() {
    return {
      myChartStart: "2024-07-21 00:00",
      myChartEnd: "2024-09-28 00:00",
      rows: [],
      // masAllFormParams: this.currentFormConfig(),
      // currentApiFormMethod: this.currentApiFormMethodComp(),
      ApiData: [],
      ApiDataGant: [],
      bShowFilter: false,
      objGetParams: {},
      masAllFilterParams: this.currentFilterConfig(),
      masApi_total: 0,
      masApiGant_total: 0,
      strCurrentTab: "table",
      TheData: [],
      planButtons: {},
    };
  },
  computed: {
    isBoss() {
      return (
        this.$GVO && this.$GVO.my_profile && this.$GVO.my_profile.is_boss > 0
      );
    },
  },
  methods: {
    isAutoprolongateEnabled(row) {
      return row.autoprolongate === 1 ? "Включено" : "";
    },
    fillPlanButtons() {
      this.planButtons = {};
      for (let i = 0; i < this.ApiData.length; i++) {
        let row = this.ApiData[i];
        let me = this;
        this.$set(this.planButtons, row.plan_id, [
          {
            actionType: "switcher",
            label_on: "Вкл",
            label_off: "Выкл",
            // action_model: row.act==actchange,
            action_model: row.autoprolongate == "1" ? true : false,
            changeState(apiData, state) {
              // console.log(state);
              // me.siteButtons[row.site_id].action_model=state;
              apiData.apiParam.flt.act = state ? 1 : 0;
            },
            onSuccess(data) {
              // console.log('set',data);
              let sb = me.planButtons[row.plan_id];
              sb[0].action_model = !!data.data.autoprolongate;
              me.$set(me.planButtons, row.plan_id, sb);
              // me.siteButtons[row.site_id][0].action_model=state;
              // console.log(this, data, me,row);
            },
            onClickApi: {
              apiMethod: "SET_object_plan_autoprolongate",
              apiParam: {
                obj: "marketing_export",
                flt: {
                  object_id: row.object_id,
                  plan_id: row.plan_id,
                  act: row.autoprolongate == "1" ? "0" : "1",
                },
              },
            },
          },
        ]);
      }
    },
    loadData() {
      const tab = this.strCurrentTab;
      switch (tab) {
        case "table":
          return this.getApiData();
        case "diagram":
          return this.getApiDataGant();
      }
    },
    async getData(gant = false) {
      this.objGetParams = this.$GVO.GetAllGet();
      let filter = {};
      if (!this.$GVO.isEmpty(this.objGetParams)) {
        //console.log('getApi',this.objGetParams);
        // filter = this.objGetParams;
        filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
      }
      if (gant) {
        filter.gant = true;
        filter.p = filter.pg;
      }
      return this.$GVO.ApiCall("marketing_plan.GET_marketing", {
        flt: { ...filter, c2p: 10 },
      });
    },
    getApiData() {
      this.getData()
        .then((objApi) => {
          this.ApiData = [];
          this.masApi_total = 0;
          if (objApi.success === true) {
            if (objApi.data.length > 0) {
              this.ApiData = objApi.data;
              if (objApi.total != undefined) {
                this.masApi_total = objApi.total;
              }
              this.fillPlanButtons();
            } else {
              this.ApiData = [];
            }
          }
        })
        .catch((errorObjApi) => {
          // console.log(errorObjApi);
          this.masApi_total = 0;
          this.ApiData = [];
        });
    },
    getColor() {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
      return `rgb(${r}, ${g}, ${b})`;
    },
    getApiDataGant() {
      // this.$GVO.ApiCall('marketing_plan.GET_marketing',{flt:{gant:true}})
      this.getData(true)
        .then((objApi) => {
          this.ApiDataGant = [];
          if (objApi.success === true) {
            if (objApi.data.length > 0) {
              this.ApiDataGant = objApi.data;
              if (objApi.total != undefined) {
                this.masApiGant_total = objApi.total;
              }
              let start = "9999",
                end = "0001";
              this.rows = [];
              for (let i = 0; i < this.ApiDataGant.length; i++) {
                const element = this.ApiDataGant[i];
                let mBars = [];
                for (let x = 0; x < element.intervals.length; x++) {
                  const ei = element.intervals[x];
                  mBars.push({
                    myStart: `${ei.from} 00:00`,
                    // myEnd:`${ei.to} 23:59`,
                    myEnd: `${ei.to} 00:00`,
                    ganttBarConfig: {
                      backgroundColor: element.color || this.getColor(),
                      immobile: true,
                    },
                    title: element.name,
                  });
                  if (start > ei.from) start = ei.from;
                  if (end < ei.to) end = ei.to;
                }
                //console.log('marketing element');
                //console.log(element);
                this.rows.push({
                  plan_id: element.plan_id,
                  object_id: element.object_id,
                  label: /*element.name + ' - '+*/ element.full_address,
                  title: element.name,
                  bars: mBars,
                });
              }
              if (end.startsWith("9999"))
                end = moment()
                  .startOf("day")
                  .add(1, "month")
                  .format("YYYY-MM-DD HH:mm:ss");
              // start = moment().startOf("day").subtract(3,"month").format("YYYY-MM-DD HH:mm:ss")
              // console.log(start,end);

              // Вычисляем дату начала графика
              let f = this.$GVO.GetAllGet();
              if (f.pkgadd_range_date) {
                let fstart = moment(f.pkgadd_range_date.split(";")[0]);
                let gstart = moment(start);
                start = fstart
                  .max(fstart, gstart)
                  .format("YYYY-MM-DD HH:mm:ss");
              }

              this.myChartStart = start;

              this.myChartEnd = moment(end)
                .add(1, "day")
                .format("YYYY-MM-DD HH:mm:ss");
            } else {
              this.ApiDataGant = [];
              this.rows = [];
            }
          }
        })
        .catch((errorObjApi) => {
          // console.log(errorObjApi);
          this.ApiDataGant = [];
        });
    },

    OnFilterApply(data) {
      if (
        typeof data != "undefined" &&
        typeof this.objGetParams["p"] != "undefined"
      ) {
        delete this.objGetParams["p"];
      }

      for (const key in this.objGetParams) {
        if (Object.hasOwnProperty.call(this.objGetParams, key)) {
          if (this.objGetParams[key] == "") delete this.objGetParams[key];
        }
      }
      let strItogGetParams = this.$GVO
        .ObjToQueryString(this.objGetParams)
        .substr(1);
      //console.log('OnFilterApply',strItogGetParams,this.objGetParams);
      this.$router.push({ path: location.pathname + "?" + strItogGetParams });
      eventEmitter.$emit("OnFilterApply", this.objGetParams);
      this.loadData();

      // this.getApiData();
    },
    currentFilterConfig() {
      this.$GVO
        .ApiCall("marketing_plan.GET_FILTER", {})
        .then((objApi) => {
          //console.log(objApi);
          if (objApi.success) {
            //this.masAllFilterParams = objApi.config;
            this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
            eventEmitter.$emit("OnFilterConfigLoad", this.masAllFilterParams);
          }
        })
        .catch((errorObjApi) => console.error(errorObjApi));
      return [];
    },
    pClick(e) {
      let strItogGetParams = "";
      let objItogGetParams = this.$GVO.GetAllGet();
      // this.objGetParams['p'] = parseInt(e);
      objItogGetParams.p = parseInt(e);
      strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
      this.$router.push({ path: location.pathname + "?" + strItogGetParams });
      // this.OnFilterApply(strItogGetParams);
      this.loadData();
      // this.getApiData();
      // this.objGetParams['p'] = parseInt(e);
      // this.OnFilterApply();
    },
    pClickGant(e) {
      let strItogGetParams = "";
      let objItogGetParams = this.$GVO.GetAllGet();
      // this.objGetParams['pg'] = parseInt(e);
      objItogGetParams.pg = parseInt(e);
      strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
      this.$router.push({ path: location.pathname + "?" + strItogGetParams });
      // this.OnFilterApply(strItogGetParams);
      this.loadData();
      // this.getApiData();
      // this.objGetParams['pg'] = parseInt(e);
      // this.OnFilterApply();
    },
    OnTabChange(strTabId) {
      this.strCurrentTab = strTabId;
      this.loadData();
      // if(strTabId=='diagram'){
      // 	this.getApiDataGant();
      // }else{
      // 	this.getApiGant();
      // }
      //let url = new URL(location);
      //url.searchParams.set('tab',strTabId);
      //this.$router.replace({path: url.search});
      //this.getApiData();
    },
  },
  mounted() {
    //this.getApiData();
  },
};
</script>
<style>
.g-timeaxis-day > div {
  height: auto !important;
}

.g-gantt-row {
  height: 50px !important;
}
.g-gantt-row .g-gantt-bar {
  top: 7px;
}
.g-gantt-row > .g-gantt-row-bars-container {
  width: 85% !important;
}

/*
.MarketingPlans .bntGroup{
	position: absolute;
	z-index: 1;
	right: 40px;
}
*/
.MarketingPlans .nav-pills .nav-item .nav-link {
  padding: 1px 23px;
}

#g-timeaxis {
  max-height: 100px;
}
</style>
